import ConfigManager from "@/config/ConfigManager"
import BzbsApi from "@/core/Http/BzbsApi"
import { DropdownListValue } from "@/helper/FormHelper"
import { map } from "rxjs"

export default {
    apiGetTitleName: function () {
        let url = ConfigManager.getApiModuleUrl() + "/tni/profile_titles?isActive=true"
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(url, null, null).pipe(map((res) => {
                // console.log(res.data)
                return res.data
            })).subscribe({
                next: (rawList) => {
                    let builder = new DropdownListValue()
                    for (const item of rawList) {
                        builder.add(item.Title, item.Title)
                    }
                    resolve(builder.getList())
                },
                error: (err) => {
                    reject(err)
                }
            })
        })
    },
    apiGetLicensePlateProvinces: function () {
        let url = ConfigManager.getApiModuleUrl() + "/tni/license_plate_provinces"
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(url, null, null).pipe(map((res) => {
                // console.log(res.data)
                return res.data
            })).subscribe({
                next: (rawList) => {
                    let builder = new DropdownListValue()
                    for (const item of rawList) {
                        builder.add(item.ProvinceDisplayName, item.ProvinceCode, item.ProvinceName)
                    }
                    resolve(builder.getList())
                },
                error: (err) => {
                    reject(err)
                }
            })
        })
    },
    apiSubmitClaimNonRegister: function (params) {
        let url = ConfigManager.getApiModuleUrl() + "/tni/claim_unregistered"
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsPost(url, null, params).pipe(map((res) => {
                // console.log(res.data)
                return res.data
            })).subscribe({
                next: (data) => {
                    resolve(data)
                },
                error: (err) => {
                    reject(err)
                }
            })
        })
    }
}